var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSustainability(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#e2e7f6",
    d: "M50 52H36v-2h14a4 4 0 004-4V32h2v14a6.006 6.006 0 01-6 6z",
    "data-original": "#e2e7f6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#e2e7f6",
    d: "M51 15h2v6h-2zm6 0h2v6h-2z",
    "data-original": "#e2e7f6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#6bc13b",
    d: "M19.707 41.707l-1.414-1.414 1.171-1.172A8.6 8.6 0 0022 33v-1h2v1a10.581 10.581 0 01-3.122 7.535z",
    "data-original": "#6bc13b"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#559b2d",
    d: "M35 15v6a12 12 0 01-12 12v-6a12 12 0 0112-12z",
    "data-original": "#559b2d"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#4d8c28",
    d: "M23 33a12 12 0 01-12-12v-6a12 12 0 0112 12v6z",
    "data-original": "#4d8c28"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#4caf50",
    d: "M21.945 33.947a8.582 8.582 0 01-2.481 5.174l-1.171 1.172 1.414 1.414 1.171-1.172a10.57 10.57 0 003.076-6.583A13.008 13.008 0 0036 21v-6a1 1 0 00-1-1 13.017 13.017 0 00-12 8.008A13.017 13.017 0 0011 14a1 1 0 00-1 1v6a13.011 13.011 0 0011.945 12.947zM34 16.045V21a11.015 11.015 0 01-10 10.955V27a11.015 11.015 0 0110-10.955zm-22 0A11.015 11.015 0 0122 27v4.955A11.015 11.015 0 0112 21z",
    "data-original": "#000000"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#4caf50",
    d: "M61 20h-2v-5h-2v5h-4v-5h-2v5h-2a1 1 0 00-1 1v6a7 7 0 006 6.92V46a4 4 0 01-4 4H37v-2a3 3 0 00-1.984-2.811 14.849 14.849 0 013.79-9.372A21 21 0 0021.861 1.029 21.2 21.2 0 002 22.185a20.946 20.946 0 005.379 13.839 14.144 14.144 0 013.607 9.165A2.994 2.994 0 009 48v6a3 3 0 003 3h4.08a6.991 6.991 0 0013.84 0H34a3 3 0 003-3v-2h13a6.006 6.006 0 006-6V33.92A7 7 0 0062 27v-6a1 1 0 00-1-1zM12 47h22a1 1 0 011 1v2H11v-2a1 1 0 011-1zM4 22.167a19.184 19.184 0 0117.967-19.14A18.994 18.994 0 0137.3 34.5 16.864 16.864 0 0033.025 45H12.977a16.129 16.129 0 00-4.111-10.313A18.956 18.956 0 014 22.167zM23 61a5.009 5.009 0 01-4.9-4h9.8a5.009 5.009 0 01-4.9 4zm12-7a1 1 0 01-1 1H12a1 1 0 01-1-1v-2h24zm25-32v2H50v-2zm-5 10a5.006 5.006 0 01-5-5v-1h10v1a5.006 5.006 0 01-5 5z",
    "data-original": "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSustainability);
export default __webpack_public_path__ + "static/media/sustainability.d4c59b5e6207f3a0d6b612e1b688f4e0.svg";
export { ForwardRef as ReactComponent };